<template>
  <div class="wlx-news-backstage-wrapper">
    <div class="yk-wrap-fixeds">
      <header class="u-school-manager-head">
        <el-form :inline="true" size="small">
          <div class="dd-search-form-news">
            <el-form-item>
              <el-input v-model="cName" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="cType" placeholder="请选择类型">
                <el-option label="全国物流职业教育教学指导委员会（2021—2025年）专门（专业）委员会委员候选人推荐表" :value="0"></el-option>
                <el-option label="全国物流职业教育教学指导委员会下设专业委员会候选人推荐表" :value="1"></el-option>
                <el-option label="全国物流职业教育教学指导委员会专业工作组成员候选人推荐表" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="searchDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="创建开始日期"
                end-placeholder="创建结束日期"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <!-- <el-form-item>
              <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
            </el-form-item> -->
            <el-form-item>
              <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
            </el-form-item>
            <el-form-item>
              <a class="export-button-a" style="color:#fff;margin-left:10px;" :href="exportExam">导出</a>
            </el-form-item>
          </div>
        </el-form>
      </header>

      <div class="u-table-main">
        <el-table
          ref="multipleeeeTable"
          :data="list"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column prop="id" type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="Name" label="姓名"></el-table-column>
          <el-table-column prop="BornDate" label="出生年月"></el-table-column>
          <el-table-column prop="Company" label="单位"></el-table-column>
          <el-table-column prop="CompanyType" label="单位性质">
            <template slot-scope="scope">
              <span v-if="scope.row.Type==0">
                {{scope.row.CompanyType}}
                <!-- <span v-if="scope.row.CompanyType == 1">本科</span>
                <span v-if="scope.row.CompanyType == 2">高职</span>
                <span v-if="scope.row.CompanyType == 3">中职</span> -->
              </span>
              <span v-else-if="scope.row.Type==1">
                <span v-if="scope.row.CompanyType == 1">高职</span>
                <span v-if="scope.row.CompanyType == 2">企业</span>
                <span v-if="scope.row.CompanyType == 3">中职</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="Position" label="职务"></el-table-column>
          <el-table-column prop="Degree" label="学位"></el-table-column>
          <el-table-column prop="Research" label="研究方向" ></el-table-column>
          <el-table-column prop="WorkMajor" label="目前从事专业"></el-table-column>
          <el-table-column prop="WorkMajor" label="拟推荐为">
            <template slot-scope="scope">
              <span v-if="scope.row.Type==0">
                {{scope.row.RecommendType}}
                <!-- <span v-if="scope.row.RecommendType==1">物流管理专业工作组</span>
                <span v-if="scope.row.RecommendType==2">物流工程专业工作组</span>
                <span v-if="scope.row.RecommendType==3">采购管理专业建设工作组</span>
                <span v-if="scope.row.RecommendType==4">青年教师工作组</span>
                <span v-if="scope.row.RecommendType==5">冷链物流专业建设工作组成员</span>
                <span v-if="scope.row.RecommendType==6">供应链管理专业工作组</span> -->
              </span>
              <span v-if="scope.row.Type==1">{{scope.row.RecommendType >= 1 && scope.row.RecommendType <= typeList.length ? typeList[scope.row.RecommendType-1]:""}}</span>
              <span v-if="scope.row.Type==2"> {{scope.row.RecommendType}}</span>
               
            </template>
          </el-table-column>
          <el-table-column prop="Mobilephone" label="联系电话" ></el-table-column>
          <el-table-column prop="WorkMajor" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.Type==0">教育部高等学校物流管理与工程类专业教学指导委员会工作组增补成员推荐表</span>
              <span v-if="scope.row.Type==1">全国物流职业教育教学指导委员会下设专业委员会候选人推荐表</span>
              <span v-if="scope.row.Type==2">全国物流职业教育教学指导委员会专业工作组成员候选人推荐表</span>
            </template>
          </el-table-column>
          <el-table-column prop="dateCreated" label="创建时间" ></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
                <el-button
                  size="mini"
                  class="el-icon-view"
                  @click="gocheck(scope.row.id,scope.row.Type)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                <el-button
                  size="mini"
                  class="el-icon-edit"
                  @click="goedit(scope.row.id,scope.row.Type)"
                  type="primary"
                ></el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                <el-button
                  size="mini"
                  type="danger"
                  class="el-icon-delete"
                  @click="deleteMajor(scope.row.id)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="news-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      viewNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      industryField: "",
      elevel: 0,
      companyName: "",
      jobsName:"",
      phone:"",
      needProvince:"",
      needNumber:"",
      abilityRequirements:"",
      majorRequirements:"",
      note:"",
      /* --------------------------------------- */
      id: "",
      ids: [],
      cName:"",
      cType:"",
      searchDate:[],
      options: [
        {
          label: "高职",
          value: 1
        },
        {
          label: "中职",
          value: 2
        }
      ],
      value: "",
      needJobsId: "",
      urlAliyunOSS: "/api/design/osssign/getsign",
      typeList:["高职现代物流管理专业委员会", "高职物流技术类专业委员会", "高职冷链物流技术与管理专业委员会", "高职航空物流管理专业专业委员会", "高职铁路与港口物流管理专业委员会", "高职工程物流管理专业委员会", "高职采购与供应链运营专业委员会", "高职本科物流类专业委员会", "中职物流管理与技术专业委员会", "中职国际货运代理专业委员会", "中职冷链物流服务与管理专业委员会", "师资建设专业委员会", "课程思政建设专业委员会", "两业融合专业委员会", "国际交流与合作专业委员会"],
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },{
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            },
          }]
        },
    };
  },
  components: {
    imageUpload
  },
  computed: {
      exportExam: function() {
          var startDate = "";
          var endDate = "";
          if(this.searchDate==null){
            this.searchDate = [];
          }
          if(this.searchDate.length>0){
            startDate = this.searchDate[0].getFullYear() + "-" +(this.searchDate[0].getMonth() + 1)+"-"+this.searchDate[0].getDate();
            endDate = this.searchDate[1].getFullYear() + "-" +(this.searchDate[1].getMonth() + 1)+"-"+this.searchDate[1].getDate();
          }

          return (
              "/api/XOrg/Candidate/exportExcel?name=" +
              this.cName +
              "&type=" +
              this.cType +
              "&startDate=" +
              startDate +
              "&endDate=" +
              endDate
          );
      }
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getCandidateList();
  },
  methods: {
    getCandidateList(page) {
      
      var startDate = "";
      var endDate = "";
      if(this.searchDate==null){
        this.searchDate = [];
      }
      if(this.searchDate.length>0){
        startDate = this.searchDate[0].getFullYear() + "-" +(this.searchDate[0].getMonth() + 1)+"-"+this.searchDate[0].getDate() +" 00:00:00";
        endDate = this.searchDate[1].getFullYear() + "-" +(this.searchDate[1].getMonth() + 1)+"-"+this.searchDate[1].getDate() +" 23:59:59";
      }

      var that = this;
      this.$http
        .post("/api/XOrg/Candidate/getCandidateList", {
          page: page,
          pageSize: this.pageSize,
          name: that.cName,
          type:that.cType,
          startDate:startDate,
          endDate:endDate
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getCandidateList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCandidateList();
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.id);
      });
    },
    goedit(id,type){
      if(type==0){
        this.$router.push({
          name: "candidateTableEdit",
          params:{
            id:id,
            isedit:false
          }
        });
      }else if(type==1){
        this.$router.push({
          name: "rcommendaTableEdit",
          params:{
            id:id,
            isedit:false
          }
        });
      }else if(type==2){
        this.$router.push({
          name: "candidateTableEditTwo",
          params:{
            id:id,
            isedit:false
          }
        });
      }
    },
    gocheck(id,type){
      if(type==0){
        this.$router.push({
            name: "candidateTableEdit",
            params:{
              id:id,
              isedit:true
            }
        });
      }else if(type==1){
        this.$router.push({
          name: "rcommendaTableEdit",
          params:{
            id:id,
            isedit:false
          }
        });
      }else if(type==2){
        this.$router.push({
          name: "candidateTableEditTwo",
          params:{
            id:id,
            isedit:false
          }
        });
      }
    },
    deleteMajor(id) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // this.DeleteSchoolNews(id)
          var that = this;
          this.$http
            .post("/api/XOrg/Candidate/deleteCandidate", {
              ids: id
            })
            .then(rst => {
              if (rst.code === 1) {
                that.$message({
                  message: rst.msg,
                  type: "success"
                });
                that.getCandidateList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getCandidateList(1);
    },
    deleteAll() {
      if (this.ids.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择信息数据",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // DeleteSchoolNews(this.ids)
          var that = this;
          this.$http
            .post("/api/XOrg/Candidate/deleteCandidate", {
              ids: that.ids
            })
            .then(rst => {
              if (rst.code === 1) {
                this.$message({
                  message: rst.msg,
                  type: "success"
                });
                this.getCandidateList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>


<style lang='scss'>
.wlx-news-backstage-wrapper {
  .news-page-con {
    padding: 20px 0;
    text-align: center;
  }
  .dd-search-form-news{
      margin: 13px 0px 0 0;
  }
  .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
    }
}
</style>
